import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  min_length_name = 2;
  max_length_name = 150;
  min_length_code = 2;
  max_length_code = 10;
  min_length_address = 10;
  max_length_address = 250;
  // min_length_email = 5; // minimum length are not required for email pattern
  max_length_email = 120;
  min_length_contact = 10;
  max_length_contact = 12;
  min_length_description = 10;
  max_length_description = 150;
  max_length_credits = 20;


  location_name_pattern = /^[a-zA-Z ]+$/;
  name_pattern = /^[a-zA-Z0-9][a-zA-Z0-9 .]*$/;
  code_pattern = /^[a-zA-Z0-9]+$/;
  address_pattern = /^[a-zA-Z0-9 !@#$%&*()-_+={},|:;"'<>,.?/]+$/;
  email_pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  year_range_pattern = /^\d{4}-\d{4}$/;
  contact_pattern = /^[0-9]+$/;
  aadhar_pattern = /^\d{12}$/;
  pan_pattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  gst_pattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}pr[A-Z]{1}[0-9]{1}$/;
  pincode_pattern = /^[0-9]{6}$/;
  new_name_pattern = /^[A-Za-z][A-Za-z .]*$/;
  roll_number_pattern = /^[A-Za-z0-9][A-Za-z0-9/-]*$/;
  // validation.service.ts
  password_complex_pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

}
